import { RESOURCE_TITLE_MAX_LENGTH } from '../constants';

/**
 * Cuts a generated resource's name down to what a page will show of it.
 *
 * A name the learner typed can run to any length, and every place one is shown
 * — a heading, a breadcrumb, a row in the table — has a shape of its own to
 * keep. Cutting it in one place means all of them cut it the same way, and the
 * flag says whether anything was lost, which is what tells the page to offer the
 * whole name some other way.
 *
 * @param {String} name The resource's name
 * @param {Number} maxLength How much of it to keep
 * @returns {Object} { text, isTruncated }
 */
export const truncateTitle = (name = '', maxLength = RESOURCE_TITLE_MAX_LENGTH) => {
  if (name.length <= maxLength) return { text: name, isTruncated: false };

  // Trimmed so the ellipsis follows the last word rather than a space.
  return { text: `${name.slice(0, maxLength).trimEnd()}…`, isTruncated: true };
};
